import { generatePath } from '@ps/web-core-utils';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';

import Redirect from '@swf/components/Redirect/Redirect';
import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import ServiceUnavailable from '@swf/components/ServiceUnavailable/ServiceUnavailable';
import { Header } from '@swf/core/enums';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { initModuleNativeClient, theme, useWidgetTheme } from '@swf/poker';

import styles from './PokerHomeGamesWidget.scss';
import Invite from './components/Invite/Invite';
import LandingPage from './components/LandingPage/LandingPage';
import Layout from './components/Layout/Layout';
import Promotion from './components/Promotion/Promotion';
import useCheckHGPath from './hooks/useCheckHGPath';
import useHandleNativeBack from './hooks/useHandleNativeBack';
import { homeGamesWidgetModel } from './model';

initModuleNativeClient('homegames');

const PokerHomeGamesWidget: WidgetFC = () => {
  const serviceState = useSelector((state: RootState) =>
    select.system.getStatus(state, 'homegames')
  );
  const { homeGamesInvite = '', homeGamesPromotion = '' } = useSelector(select.cms.getAliases);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const isEmbeddedRoute = useSelector(select.location.isEmbeddedRoute);
  const promoPath = generatePath(homeGamesPromotion, { clubId: ':clubId', clubName: ':clubName' });
  const isInHomeGames = useCheckHGPath();

  useWidgetTheme();
  useHandleNativeBack();

  if (serviceState === 'red') {
    return <ServiceUnavailable />;
  }

  return (
    <>
      <Vary by={[Header.Auth]} />
      <div
        className={classNames(styles.wrapper, theme.defaults, {
          [styles.embedded]: isEmbeddedRoute,
          [styles.disableSelect]: isMobileEmbedded
        })}
      >
        {isAuthenticated ? (
          <Layout />
        ) : (
          <>
            <Switch>
              {!!promoPath && <Route path={promoPath} component={Promotion} />}
              <Route path={generatePath(homeGamesInvite, {})} component={Invite} />
              {isInHomeGames && <Redirect alias="homeGamesLandingPage" />}
            </Switch>
            <LandingPage />
          </>
        )}
      </div>
    </>
  );
};

PokerHomeGamesWidget.model = homeGamesWidgetModel;

export { styles };
export default PokerHomeGamesWidget;
